// extracted by mini-css-extract-plugin
export default {"bubble":"iypRI5_htnM1fM4I4vNg","primaryColor":"bPzB_sP75bkKJ_cAQah_","warningColor":"i6GTziAodA06IxbmiP8p"};